var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProstir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 272.1 133.2",
    enableBackground: "new 0 0 272.1 133.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "none",
    width: 272.1,
    height: 133.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.25,0,0,-1.25,0,989.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.162168,0.162168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#1A468E",
    d: "M846.6,4590.6v-101.1h-24.5v101.2h-27.2v21.5H874v-21.6H846.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#1A468E",
    d: "M412.5,4612.3v-122.8h-24.5v101.2h-49.1v-101.2h-24.6v122.8H412.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    fill: "#1A468E",
    d: "M461.4,4555.6h9.2c4.6,0,10.5,0,15.6,3.9c4.4,3.5,6.6,9,6.6,14.4c0,6.8-3.3,11.4-6.8,14 c-5,3.5-11.2,3.9-16.9,3.9h-7.7V4555.6L461.4,4555.6z M472.5,4612.3c13.8,0,23.4-1.5,32.4-9.4c9.9-8.8,12.5-20.8,12.5-29.6 c0-4.8-0.7-18-10.1-27.4c-6.8-6.8-16.9-10.9-31.1-10.9h-14.9v-45.5h-24.5v122.8H472.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "#1A468E",
    d: "M770.4,4493.9c-7.4-3.9-17.1-7.2-30.4-7.2c-21.5,0-34.6,7.4-44.9,17.1 c-14.2,13.6-19.7,28.9-19.7,46.9c0,22.3,9.2,38.3,19.7,48c12.3,11.6,27.6,16.2,45.1,16.2c8.7,0,19-1.5,30.2-7.5v-28 c-11.2,12.9-25.2,13.8-29.6,13.8c-24.7,0-40.7-20.2-40.7-42.9c0-27.2,21-42,41.6-42c11.4,0,21.5,5,28.7,13.4V4493.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22_1_",
    fill: "#1A468E",
    d: "M898.5,4489.5h24.5v122.8h-24.5V4489.5L898.5,4489.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#1A468E",
    d: "M972.1,4555.6h9.2c4.6,0,10.5,0,15.6,3.9c4.4,3.5,6.6,9,6.6,14.4c0,6.8-3.3,11.4-6.8,14 c-5,3.5-11.2,3.9-16.9,3.9h-7.7V4555.6L972.1,4555.6z M983.3,4612.3c13.8,0,23.4-1.5,32.4-9.4c9.9-8.8,12.5-20.8,12.5-29.6 c0-4.8-0.7-18-10.1-27.4c-6.8-6.8-16.9-10.9-31.1-10.9h-14.9v-45.5h-24.5v122.8H983.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    fill: "#FBC709",
    d: "M584.1,4550.7c0,0.1,0,0.1,0,0.2c0,6.9,5.6,12.4,12.4,12.4c6.9,0,12.4-5.6,12.4-12.4 c0-6.8-5.5-12.4-12.3-12.4v-16.8c16.1,0,29.1,13.1,29.1,29.2c0,16.1-13.1,29.2-29.2,29.2c-16.1,0-29.2-13.1-29.2-29.2 c0-0.1,0-0.1,0-0.2H584.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fill: "#1A468E",
    d: "M639.5,4572c3.1-6.4,4.9-13.5,4.9-21.1c0-26.5-21.5-47.9-47.9-47.9 c-26.5,0-47.9,21.5-47.9,47.9c0,25.5,20,46.4,45.1,47.9l12,18.3c-3,0.4-6,0.6-9.1,0.6c-36.9,0-66.8-29.9-66.8-66.8 c0-36.9,29.9-66.8,66.8-66.8c36.9,0,66.8,29.9,66.8,66.8c0,14.4-4.6,27.7-12.3,38.6L639.5,4572"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProstir);
export default __webpack_public_path__ + "static/media/prostir.24b41886a94eebb8c4db71dd6453e2b4.svg";
export { ForwardRef as ReactComponent };